import React from "react";
import ButtonTemplate from "../Templates/ButtonTemplate";

const Button = (props) => {
  const modifiedExtraProps = { ...props.extraProps, role: "button", tabIndex: 0 };
  return (
    <ButtonTemplate
      { ...props }
      extraProps={ modifiedExtraProps }
    />
  );
}

export default Button;
